import React from "react";
import { useTranslation } from "react-i18next";
import { ProgressRow } from "../../hooks/useProgressData";
import TinyDonut from "../charts/TinyDonut";
import ProgressTableSkeleton from "./skeletons/ProgressTableSkeleton";

interface ProgressTableProps {
  rows: ProgressRow[];
  isLoading?: boolean;
}

const ProgressTable: React.FC<ProgressTableProps> = ({ rows, isLoading = false }) => {
  const { t } = useTranslation();
  return (
    <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
      <div className="grid grid-cols-[2fr_1.2fr_1fr_1.2fr_1.2fr] gap-3 bg-slate-100 px-4 py-3 text-sm font-semibold text-slate-700">
        <div>{t("dashboard_reports.object_name")}</div>
        <div>{t("dashboard_reports.percent_complete")}</div>
        <div className="text-right">{t("dashboard_reports.total_planned")}</div>
        <div className="text-right">{t("dashboard_reports.actual_installed")}</div>
        <div className="text-right">{t("dashboard_reports.remaining_overdue")}</div>
      </div>
      {isLoading && <ProgressTableSkeleton rows={5} />}
      {!isLoading && rows.map((row) => (
        <div
          key={row.type}
          className="grid grid-cols-[2fr_1.2fr_1fr_1.2fr_1.2fr] items-center gap-3 border-t border-slate-100 px-4 py-3"
        >
          <div className="flex items-center gap-2">
            <span className="font-semibold text-slate-900 max-w-[250px] break-all">{row.type}</span>
          </div>

          <div className="flex items-center gap-3">
            <TinyDonut percent={row.pct} />
            <span className="w-10 text-right font-semibold text-slate-900">
              {row.pct}%
            </span>
          </div>

          <div className="text-right text-slate-900">{row.total}</div>
          <div className="text-right font-semibold text-slate-900">{row.actual}</div>
          <div
            className={`text-right font-bold ${
              row.remaining < 0 ? "text-rose-700" : "text-emerald-700"
            }`}
          >
            {row.remaining}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProgressTable;
